import {BaseComponent} from "../../../BaseComponent";
import * as React from "react";
import {CustomDropzone} from "../../Dropzone/CustomDropzone";
import {DropEvent} from "react-dropzone";
import {BottoneAPI} from "../../../BottoneAPI";
import * as Dati from "../../../../Dati";
import {CDocument, CDocumentExtended} from "../../../../Dati";
import {Trad} from "../../../Trad";

export enum FieldType {
    LEFT = "LEFT",
    CENTER = "CENTER",
    SIBLING = "SIBLING"
}

export interface IAddDocumentField {
    Label: string;
    Placeholder: string;
    KeyName: string;
    Readonly: boolean;
    Icon: string;
    Type: FieldType;
}

export class AddDocumentFieldClass implements IAddDocumentField {
    KeyName: string;
    Label: string;
    Placeholder: string;
    Readonly: boolean;
    Icon: string;
    Type: FieldType;

    constructor({KeyName, Label, Placeholder, Readonly, Icon, Type}: IAddDocumentField) {
        this.KeyName = KeyName;
        this.Label = Label;
        this.Placeholder = Placeholder;
        this.Readonly = Readonly;
        this.Icon = Icon;
        this.Type = Type;
    }
}

interface IAddDocumentComponentProps {
    OnComponentChange: () => any;
    OnSelect: (acceptedFiles: File[], rejectedFiles: File[], event?: DropEvent) => any;
    Fields: IAddDocumentField[];
    OnFileSaved: (dati: Dati.CRisAPI) => void;
    OnErroreBottoneAPI: (sender: BottoneAPI) => void;
    OnSubmitSave: (file: File, AdditionalData: CDocument) => void;
    InputFile?: File;
    AdditionalData: CDocumentExtended | null;
    SaveURL?: string;
    AcceptedFiles?: string;
    SpecialInformationEnabled?: boolean;
    AddEnabled?: boolean
}

interface IAddDocumentComponentState {
    [key: string]: any;
}

export class AddDocumentComponent extends BaseComponent<IAddDocumentComponentProps, IAddDocumentComponentState> {
    AdditionalData: any;

    constructor(props: any) {
        super(props);
        this.AdditionalData = this.props.AdditionalData;
        this.state = {...this.generateStateFields(props)};
        this.clearState = this.clearState.bind(this);
        this.OnInputChange = this.OnInputChange.bind(this);
        this.GetAdditionalData = this.GetAdditionalData.bind(this);
    }

    shouldComponentUpdate(nextProps: Readonly<IAddDocumentComponentProps>, nextState: Readonly<IAddDocumentComponentState>, nextContext: any): boolean {
        if ((this.props.InputFile && !nextProps.InputFile) || (!this.props.InputFile && nextProps.InputFile)) {
            this.setState({...this.generateStateFields(nextProps)});
        }
        return true;
    }

    private OnInputChange(e: any) {
        e.persist();
        this.setState({[e.target.name]: e.target.value});
    }

    private clearState() {
        this.AdditionalData = null;
        this.props.OnSelect([], []);
        this.setState({...this.generateStateFields(this.props, true)});
    }

    private generateStateFields(props: any, IsClear: boolean = false) {
        let obj = {};
        let Document = new CDocument();
        if (this.AdditionalData && !IsClear) {
            this.props.Fields.forEach(field => {
                // @ts-ignore
                obj[field.KeyName] = this.AdditionalData[field.KeyName] ? this.AdditionalData[field.KeyName] : "";
            });
        } else {
            this.props.Fields.forEach(field => {
                obj[field.KeyName] = Document[field.KeyName] ? Document[field.KeyName] : "";
            });
        }
        if (!IsClear && props.InputFile) {
            obj["OriginalFileName"] = props.InputFile.name;
            obj["DownloadFileName"] = props.InputFile.name;
        }
        return obj;
    }

    private GetFileIcon() {
        let icon: string = "";
        let ImageType: any = null;
        if (this.props.InputFile) {
            ImageType = this.props.InputFile.type
        } else if (this.AdditionalData) {
            ImageType = this.AdditionalData.MIME
        }
        if (ImageType) {
            if (ImageType == "application/doc") {
                icon = "./assets/metronic/media/files/doc.svg";
            } else if (ImageType.type == "application/pdf") {
                icon = "./assets/metronic/media/files/pdf.svg"
            } else if ((ImageType == "image/jpeg" || ImageType == "image/png")) {
                icon = "./assets/metronic/media/files/jpg.svg"
            } else {
                icon = "";
            }
        }

        return icon;
    }

    private getFields() {
        return this.props.Fields.map(field => {
            return this.props.SpecialInformationEnabled || ((field.KeyName !== "MIME") && (field.KeyName !== "SHA256")) ?
                this.getField(field) : null;

        });
    }

    GetAdditionalData() {
        let DataToSend = Object.assign({}, this.state) as CDocument;
        let Document = new CDocument();
        const data = Object.entries(Document);
        data.forEach(entr => {
            DataToSend[entr[0]] = entr[1] ? entr[1] : DataToSend[entr[0]];
        });
        delete DataToSend["Type"];
        DataToSend["ID_Document"] = DataToSend["ID_Document"] ? DataToSend["ID_Document"] : 0;
        return DataToSend as CDocument;
    }

    private OnFileSaved(data: any) {
        this.props.OnComponentChange();
        this.props.OnFileSaved(data)
    }

    private getButtons() {
        if (this.props.AddEnabled != undefined && this.props.AddEnabled) {
            return <div className="kt-widget16__item file-options">
                <BottoneAPI InviaFile Default Testo={Trad.Trad("Salva")}
                    ClasseAttivo={"btn btn-label-brand btn-bold btn-sm"}
                    URL={this.props.SaveURL ? this.props.SaveURL : "/api/Document/"}
                    Metodo="POST"
                    OnInvio={(s) => this.props.OnSubmitSave(this.props.InputFile as File, this.GetAdditionalData())}
                    OnClick={(s, d) => this.OnFileSaved(d)}
                    OnErrore={(s, e) => this.props.OnErroreBottoneAPI(s)} />
                <button onClick={this.props.OnComponentChange} type="button"
                    className="btn btn-label-brand btn-bold btn-sm">Cancel
            </button>
                <button onClick={this.clearState} type="button"
                    className="btn btn-label-brand btn-bold btn-sm">Remove
            </button>
                <CustomDropzone OnlySelect={true} OnDrop={this.props.OnSelect} AcceptedFiles={this.props.AcceptedFiles}>
                    <button type="button" className="btn btn-label-brand btn-bold btn-sm">
                        Select
                </button>
                </CustomDropzone>
            </div>
        } else {
            return false;
        }
    }

    private getField(field: IAddDocumentField) {
        return <div key={field.KeyName}
                    className={"kt-widget16__item " + this.getFieldClassName(field.Type, field.Readonly)}>
                            <span className="kt-widget16__date">
                                {field.Label}
                            </span>
            {field.Icon ?
                <img defaultValue="" src={this.GetFileIcon()} alt="" width="32px"/>
                :
                <input className="form-control kt-input" value={this.state[field.KeyName] || ""}
                       onChange={this.OnInputChange} name={field.KeyName}
                       readOnly={field.Readonly}
                       placeholder={field.Placeholder} type="text"/>}
        </div>;
    }

    private getFieldClassName(type: FieldType, readOnly: boolean): string {
        let className = "";
        if (type === FieldType.LEFT) {
            className = "left-field";
        } else if (type === FieldType.CENTER) {
            className = "center-field";
        } else {
            className = "sibling-field col-md-6";
        }
        return readOnly ? className + " read-only" : className;
    }

    render() {
        return <div className="add-drop-document kt-portlet kt-portlet--height-fluid">
            <div className="kt-portlet__body">
                <div className="kt-widget16">
                    <div className="kt-widget16__items">
                        {this.getFields()}
                        {this.getButtons()}
                    </div>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/custom/Document/AddDocument/AddDocumentComponent.tsx